import React, { createContext, useContext, useReducer } from 'react';
import currentScreenDataReducer, { initialCurrentScreenDataState } from '../reducers/currentScreenDataReducer';

export const CurrentScreenDataContext = createContext(null);

export const CurrentScreenDataProvider = ({ children }) => {
    const [state, dispatch] = useReducer(currentScreenDataReducer, initialCurrentScreenDataState);

    return (
        <CurrentScreenDataContext.Provider value={{ state, dispatch }}>
            {children}
        </CurrentScreenDataContext.Provider>
    );
};

export default CurrentScreenDataContext;
